import { Instagram } from "lucide-react";
import Reveal, { SectionHead } from "@/components/Reveal";

const PORTRAIT = "/fotos/foto02.jpg";

const traits = ["Despliegue", "Intensidad", "Presión", "Anticipación", "Duelos", "Equilibrio Táctico", "Asociación en Ataque"];

const ficha = [
  ["Nacimiento", "15 / 05 / 2008", "perfil-meta-birth"],
  ["Nacionalidad", "Chile", "perfil-meta-nationality"],
  ["Posición", "Volante Central", "perfil-meta-position"],
  ["Pierna hábil", "Derecha", "perfil-meta-foot"],
  ["Estatura", "1,73 m", "perfil-meta-height"],
  ["Club", "Colo-Colo", "perfil-meta-club"],
  ["Selección", "Chile Sub-17", "perfil-meta-nationalteam"],
];

export default function Perfil() {
  return (
    <section id="perfil" data-testid="perfil-section" className="relative py-28 px-6">
      <div className="max-w-6xl mx-auto">
        <SectionHead eyebrow="01 — Perfil" title="El motor del mediocampo" testId="perfil-title" />

        <div className="mt-14 grid lg:grid-cols-2 gap-12 items-start">
          <Reveal className="relative">
            <div className="relative overflow-hidden border border-neutral-800">
              <img
                src={PORTRAIT}
                alt="Cristian Díaz celebrando con puños en alto tras un partido con Colo-Colo"
                data-testid="perfil-portrait"
                className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 to-transparent" />
            </div>
            <div className="relative mt-4 sm:mt-0 sm:absolute sm:-bottom-6 sm:right-6 bg-[#0f0f0f] border border-[#d4af37]/50 px-6 py-5" data-testid="perfil-worldcup-card">
              <span className="font-tech text-[10px] uppercase tracking-[0.3em] text-neutral-500">Mundial Sub-17 FIFA</span>
              <div className="flex items-baseline gap-2 mt-1">
                <span className="font-display text-4xl font-black text-[#d4af37]">Qatar 2025</span>
              </div>
              <span className="font-tech text-[10px] uppercase tracking-[0.3em] text-neutral-500">La Roja Sub-17</span>
            </div>
          </Reveal>

          <div className="lg:pt-4">
            <Reveal delay={0.1}>
              <p className="text-base sm:text-lg text-neutral-400 leading-relaxed" data-testid="perfil-bio">
                Cristian Rodrigo Díaz Muñoz (15 de mayo de 2008) es un mediocampista
                chileno formado en las inferiores de Colo-Colo. Volante central de
                perfil derecho, fue convocado por La Roja para disputar la Copa
                Mundial Sub-17 de la FIFA Qatar 2025.
              </p>
              <p className="mt-5 text-base sm:text-lg text-neutral-400 leading-relaxed">
                En agosto de 2026 debutó en el fútbol profesional con el Cacique y un
                mes después fue titular frente a Audax Italiano por Copa Chile. Es un
                volante de despliegue e intensidad, capaz de participar en distintas
                alturas del mediocampo: presiona, anticipa, gana duelos y equilibra al
                equipo, con disposición constante para asociarse en ataque.
              </p>
            </Reveal>
            <Reveal delay={0.2} className="mt-10">
              <p className="font-tech text-xs uppercase tracking-[0.35em] text-neutral-500 mb-4">Perfil de juego</p>
              <div className="flex flex-wrap gap-2" data-testid="perfil-traits">
                {traits.map((t) => (
                  <span
                    key={t}
                    className="font-tech text-xs uppercase tracking-widest border border-neutral-800 bg-[#0f0f0f] px-4 py-2 hover:border-[#d4af37] hover:text-[#d4af37] transition-colors cursor-default"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </Reveal>
            <Reveal delay={0.3} className="mt-10">
              <p className="font-tech text-xs uppercase tracking-[0.35em] text-neutral-500 mb-4">Ficha</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-6" data-testid="perfil-ficha">
                {ficha.map(([label, value, id]) => (
                  <div key={id} data-testid={id}>
                    <span className="font-tech text-[10px] uppercase tracking-[0.3em] text-neutral-500">{label}</span>
                    <p className="font-display text-lg font-bold uppercase mt-1 leading-tight">{value}</p>
                  </div>
                ))}
                <div data-testid="perfil-meta-instagram">
                  <span className="font-tech text-[10px] uppercase tracking-[0.3em] text-neutral-500">Instagram</span>
                  <a
                    href="https://instagram.com/c.diazz6"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="perfil-instagram-link"
                    className="flex items-center gap-2 font-display text-lg font-bold uppercase mt-1 leading-tight hover:text-[#d4af37] transition-colors"
                  >
                    <Instagram size={16} className="text-[#d4af37]" /> @c.diazz6
                  </a>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
